(function ($) {


  const Init = (() => {

    let website = {},
      load = {},
      resize = {},
      resizeW = {},
      scroll = {},
      orientation = {},
      mod = {},
      anime = {},
      scrollOption = {},
      parallax = {},
      drawer = {},
      wp = {},
      slider = {},
      top = {},
      basic = {};

    website = {
      page: document.body.dataset.page,
      url: document.URL,
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
      scrollY: window.pageYOffset,
      scrollCurrent: 0,
      breakpoint: { pc: 1200, tb: 992, sp: 768, ss: 576 },
      ua: navigator.userAgent.toLowerCase(),
      isDesktop: true,
      isMobile: false,
      isFirst: true,
      animationFrame: null,

      headTag: document.getElementById('js-header'),
      footTag: document.getElementById('js-footer'),
      footPos: 0,
      // headTag       : $('#js-header'),
      // footTag       : $('#js-footer'),

      act: 'is-act',
      inact: 'is-inact',
      actView: 'is-view',
      actOpen: 'is-open',
      loaded: 'is-loaded',

      targetAnime: 'js-anime',
      actAnime: 'is-anime',
      shiftPoint: 0,
      shiftPc: 5,
      shiftSp: 10,
    };
    website.shiftPoint = website.breakpoint.tb;

    load = {
      functions: [],
      length: 0,
    };

    resize = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };
    resizeW = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };

    scroll = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };

    orientation = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };




    



    const WinLoad = {



    



      init() {



        window.addEventListener('load', function(e) {



          WinLoad.update();



        });



    



        console.log('!-- load init --!');



      },



    



      add(func) {



        load.functions.push(func);



        load.length = load.functions.length;



      },



    



      remove(func) {



        load.functions.splice(func, 1);



        load.length = load.functions.length;



      },



    



      update() {



        for ( let i = 0; i < load.length; i++ ) {



          let func = load.functions[i];



          func();



        }



      },



    



    }



    



    



    const WinResize = {



    



      init() {



        window.addEventListener('resize', function(e) {



          if ( !resize.isRunning ) {



            resize.isRunning = true;



    



            resize.animationFrame = window.requestAnimationFrame( WinResize.update );



    



            // if ( window.requestAnimationFrame ) {



            //   window.requestAnimationFrame(() => {



            //     WinResize.update();



            //   });



            // } else {



            //   setTimeout(() => {



            //     WinResize.update();



            //   }, 1000/resize.fps);



            // }



          }



        });



    



        console.log('!-- resize init --!');



      },



    



      add(func) {



        resize.functions.push(func);



        resize.length = resize.functions.length;



      },



    



      remove(func) {



        resize.functions.splice(func, 1);



        resize.length = resize.functions.length;



      },



    



      update() {



        website.winWidth  = window.innerWidth;



        website.winHeight = window.innerHeight;



        website.ua        = navigator.userAgent.toLowerCase();



    



        for ( let i = 0; i < resize.length; i++ ) {



          let func = resize.functions[i];



          func();



        }



    



        resize.isRunning = false;



      },



    



    }



    



    



    const WinResizeWidth = {



    



      init() {



        window.addEventListener('resize', function(e) {



          if ( website.winWidth != window.innerWidth && !resizeW.isRunning ) {



            resizeW.isRunning = true;



            resizeW.animationFrame = window.requestAnimationFrame( WinResizeWidth.update );



          }



        });



    



        console.log('!-- resizeW init --!');



      },



    



      add(func) {



        resizeW.functions.push(func);



        resizeW.length = resizeW.functions.length;



      },



    



      remove(func) {



        resizeW.functions.splice(func, 1);



        resizeW.length = resizeW.functions.length;



      },



    



      update() {



        for ( let i = 0; i < resizeW.length; i++ ) {



          let func = resizeW.functions[i];



          func();



        }



    



        resizeW.isRunning = false;



      },



    



    }



    



    



    const WinScroll = {



    



      init() {



        window.addEventListener('scroll', function(e) {



          if ( !scroll.isRunning ) {



            scroll.isRunning = true;



    



            scroll.animationFrame = window.requestAnimationFrame( WinScroll.update );



    



            // if ( window.requestAnimationFrame ) {



            //   window.requestAnimationFrame(() => {



            //     WinScroll.update();



            //   });



            // } else {



            //   setTimeout(() => {



            //     WinScroll.update();



            //   }, 1000/scroll.fps);



            // }



          }



        });



    



        console.log('!-- scroll init --!');



      },



    



      add(func) {



        scroll.functions.push(func);



        scroll.length = scroll.functions.length;



      },



    



      remove(func) {



        scroll.functions.splice(func, 1);



        scroll.length = scroll.functions.length;



      },



    



      update() {



        website.winHeight = window.innerHeight;



        website.scrollY   = window.pageYOffset;



    



        for ( let i = 0; i < scroll.length; i++ ) {



          let func = scroll.functions[i];



          func();



        }



    



        scroll.isRunning = false;



      },



    



    }



    



    



    const OrientationChange = {



    



      init() {



        window.addEventListener('orientationchange', function(e) {



          if ( !orientation.isRunning ) {



            orientation.isRunning = true;



    



            orientation.animationFrame = window.requestAnimationFrame( OrientationChange.update );



          }



        });



    



        console.log('!-- orientationchange init --!');



      },



    



      add(func) {



        orientation.functions.push(func);



        orientation.length = orientation.functions.length;



      },



    



      remove(func) {



        orientation.functions.splice(func, 1);



        orientation.length = orientation.functions.length;



      },



    



      update() {



        for ( let i = 0; i < orientation.length; i++ ) {



          let func = orientation.functions[i];



          func();



        }



    



        orientation.isRunning = false;



      },



    



    }



    

    
    const Modules = {
    
      init() {
        mod = {
          targetSmooth: 'js-scroll',
          smoothSpeed: 600,
    
          // targetTab       : 'js-tab',
    
          targetAccordion: 'js-accordion',
          targetAccordionSp: 'js-accordionSp',
    
          // targetModalOpen   : 'js-modal',
          // targetModalClose  : 'js-modalClose',
          // targetModalOverlay: 'js-modalOverlay',
          // actBodyModal      : 'is-modal',
    
          // targetTmpClone: 'js-tmpClone',
    
          optMagnify: {
            selector: ".js-Magnify",
            infinigall: false,
            numeratio: true,
            navTouch: false,
            onPreClose: function (obj) {
              document.documentElement.classList.remove(website.actOpen);
            },
            onContentLoaded: function (obj) {
              document.documentElement.classList.add(website.actOpen);
              $(".vbox-child img").imgViewer2({
                zoomMax: 6,
                zoomStep: 1.0,
                onReady: function () {
                  this.setZoom(2);
                  this.setZoom(1);
                }
              });
            },
    
          },
    
          // targetCursor: 'js-cursor',
          // targetCursorTag: '',
          // cursorMagnet: false,
          // cursorClass: website.act,
          // cursorOffClass: website.inact,
    
          // targetAlign     : 'js-align',
          // targetAlignList : [],
          // alignAddClass   : 'u-align_height',
        };
    
        // if (document.getElementById(mod.targetCursor) != null) {
        //   mod.targetCursorTag = document.getElementById(mod.targetCursor);
        //   this.cursor();
        // }
    
        // let alignList = document.querySelectorAll('.' + mod.targetAlign);
        // mod.targetAlignList = Array.prototype.slice.call(alignList, 0);
    
        this.viewportHeight();
        this.scrollbarWidth();
        this.iosCheck();
        this.deviceCheck();
        this.smoothScroll();
        this.dragScroll();
        // this.tabBtn();
        this.accordionBtn();
        // this.modalBtn();
        // this.tmpClone();
        this.imgMagnify();
      },
    
      viewportHeight() {
        let vh = website.winHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      },
      scrollbarWidth() {
        let element = document.createElement('div');
        element.style.visibility = 'hidden';
        element.style.overflow = 'scroll';
        document.body.appendChild(element);
        let scrollbarWidth = element.offsetWidth - element.clientWidth;
        document.body.removeChild(element);
        document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
      },
    
      iosCheck() {
        if (website.ua.indexOf('ipad') > -1 || website.ua.indexOf('iphone') > -1 || (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document)) {
          $('body').addClass('is-ios');
        } else {
          $('body').removeClass('is-ios');
        }
      },
    
      deviceCheck() {
        if (
          website.ua.indexOf('iphone') > -1 ||
          website.ua.indexOf('ipod') > -1 ||
          website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1
        ) {
          website.isDesktop = false;
          website.isMobile = true;
          $('body').removeClass('is-pc is-tb').addClass('is-sp');
        } else if (
          website.ua.indexOf('ipad') > -1 ||
          website.ua.indexOf('Android') > -1 ||
          (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
        ) {
          website.isDesktop = false;
          website.isMobile = false;
          $('body').removeClass('is-pc is-sp').addClass('is-tb');
        } else {
          website.isDesktop = true;
          website.isMobile = false;
          $('body').removeClass('is-tb is-sp').addClass('is-pc');
        }
      },
    
      smoothScroll() {
        $('.' + mod.targetSmooth + ':not([href=""])').on('click', function () {
          let href = $(this).attr("href"),
            target = $((href == "#") ? 'html' : href),
            shift = ((href != "#")) ? website.headTag.offsetHeight + 15 : 0,
            position = target.offset().top - shift;
    
          $('body,html').animate({ scrollTop: position }, mod.smoothSpeed, 'swing');
          return false;
        });
      },
    
      dragScroll() {
        // スクロールのドラッグ有効化
        jQuery.prototype.mousedragscrollable = function () {
          let target;
          $(this).each(function (i, e) {
            $(e).mousedown(function (event) {
              event.preventDefault();
              target = $(e);
              $(e).data({
                down: true,
                move: false,
                x: event.clientX,
                y: event.clientY,
                scrollleft: $(e).scrollLeft(),
                scrolltop: $(e).scrollTop(),
              });
              return false;
            });
            $(e).click(function (event) {
              if ($(e).data("move")) {
                return false;
              }
            });
          });
          $(document)
            .mousemove(function (event) {
              if ($(target).data("down")) {
                event.preventDefault();
                let move_x = $(target).data("x") - event.clientX;
                let move_y = $(target).data("y") - event.clientY;
                if (move_x !== 0 || move_y !== 0) {
                  $(target).data("move", true);
                } else {
                  return;
                }
                $(target).scrollLeft($(target).data("scrollleft") + move_x);
                $(target).scrollTop($(target).data("scrolltop") + move_y);
                return false;
              }
            })
            .mouseup(function (event) {
              $(target).data("down", false);
              return false;
            });
        };
      },
    
      // tabBtn() {
      //   $('.' + mod.targetTab).each(function(){
      //     let tabObj   = $('> li > a', this),
      //         contId   = ( $(this).data('tab') ) ? $(this).data('tab'): '',
      //         contsObj = ( contId ) ? $(contId).children('div'): $(this).next().children('div');
    
      //     tabObj.on('click', function(){
      //       let tabHref = $(this).attr('href');
    
      //       tabObj.removeClass(website.act);
      //       $(this).addClass(website.act);
    
      //       contsObj.hide();
      //       $(tabHref).fadeIn();
    
      //       return false;
      //     });
      //   });
      // },
    
      accordionBtn() {
        $('.' + mod.targetAccordion).on('click', function () {
          if ($(this).hasClass(website.act)) {
            $(this).removeClass(website.act).next().stop().slideUp('fast');
            // $(this).removeClass(website.act);
          } else {
            $(this).addClass(website.act).next().stop().slideDown();
            // $(this).addClass(website.act);
          }
        });
    
        $('.' + mod.targetAccordionSp).on('click', function () {
          if (website.winWidth < website.shiftPoint) {
            if ($(this).hasClass(website.act)) {
              $(this).removeClass(website.act).next().stop().slideUp('fast');
              // $(this).removeClass(website.act);
            } else {
              $(this).addClass(website.act).next().stop().slideDown();
              // $(this).addClass(website.act);
            }
            return false;
          }
        });
      },
    
      // modalBtn() {
      //   $(document).on('click', '.' + mod.targetModalOpen, function (e) {
      //     let href = $(this).attr("href");
      //     $('body').addClass(mod.actBodyModal);
      //     $(href).addClass(website.actOpen).parent().addClass(website.act);
      //     return false;
      //   });
    
      //   $('.' + mod.targetModalClose).each(function () {
      //     $(this).on('click', function () {
      //       // $('.' + website.actOpen + ' iframe').each(function () {
      //       //   let playerWindow = $(this)[0].contentWindow;
      //       //   playerWindow.postMessage('{"event":"command", "func":"pauseVideo", "args":""}', "*");
      //       // });
    
      //       $('body').removeClass(mod.actBodyModal);
      //       $(this).closest('.' + website.actOpen).removeClass(website.actOpen).parent().removeClass(website.act);
      //     });
      //   });
    
      //   $(document).on('click', '.' + mod.targetModalOverlay, function () {
      //     // $('.' + website.actOpen + ' iframe').each(function () {
      //     //   let playerWindow = $(this)[0].contentWindow;
      //     //   playerWindow.postMessage('{"event":"command", "func":"pauseVideo", "args":""}', "*");
      //     // });
    
      //     $('body').removeClass(mod.actBodyModal);
      //     $(this).nextAll('.' + website.actOpen).removeClass(website.actOpen).parent().removeClass(website.act);
      //   });
      // },
    
      // tmpClone() {
      //   $('.' + mod.targetTmpClone).each(function () {
      //     let targetId = $(this).data('tmp'),
      //       loopNum = $(this).data('loop');
    
      //     for (var i = 0; i < loopNum; i++) {
      //       let clone = document.getElementById(targetId).content.cloneNode(true);
      //       this.appendChild(clone);
      //     }
      //   });
      // },
    
      imgMagnify() {
        new VenoBox(mod.optMagnify);
      },
    
      // cursor() {
      //   document.addEventListener('mousemove', function (e) {
      //     if (!mod.cursorMagnet) {
      //       mod.targetCursorTag.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)';
      //     }
      //   });
    
    
      //   let linkElem = document.querySelectorAll('a, button, [data-cursor]');
      //   for (let i = 0; i < linkElem.length; i++) {
      //     linkElem[i].addEventListener('mouseover', function (e) {
      //       if (this.dataset.hover !== undefined) {
      //         mod.cursorClass = this.dataset.hover;
      //       } else {
      //         mod.cursorClass = website.act;
      //       }
      //       mod.targetCursorTag.classList.add(mod.cursorClass);
    
      //       if (this.dataset.magnet !== undefined) {
      //         mod.cursorMagnet = this.querySelector('.' + this.dataset.magnet);
      //       }
    
      //     });
      //     linkElem[i].addEventListener('mouseout', function (e) {
      //       mod.targetCursorTag.classList.remove(mod.cursorClass);
      //       mod.cursorMagnet = false;
      //     });
      //   }
    
      //   let linkOffElem = document.querySelectorAll('[data-cursor-off]');
      //   for (let i = 0; i < linkOffElem.length; i++) {
      //     linkOffElem[i].addEventListener('mouseover', function (e) {
      //       document.body.classList.add(mod.cursorOffClass);
      //     });
      //     linkOffElem[i].addEventListener('mouseout', function (e) {
      //       document.body.classList.remove(mod.cursorOffClass);
      //     });
      //   }
      // },
      // cursorMagnet() {
      //   let cursorMagnetClient = mod.cursorMagnet.getBoundingClientRect();
      //   mod.targetCursorTag.style.transform = 'translate(' + (cursorMagnetClient.left + cursorMagnetClient.width / 2) + 'px, ' + (cursorMagnetClient.top + cursorMagnetClient.height / 2) + 'px)';
      // },
    
      // alignHeight() {
      //   let alignHeight  = 0;
    
      //   mod.targetAlignList.forEach((target) => {
      //     target.style.minHeight = 'auto';
      //     target.classList.add(mod.alignAddClass);
      //     alignHeight = ( target.offsetHeight > alignHeight ) ? target.offsetHeight: alignHeight;
      //     target.classList.remove(mod.alignAddClass);
      //   });
      //   mod.targetAlignList.forEach((target) => {
      //     target.style.minHeight = alignHeight + 'px';
      //   });
      // },
    
    }
    

    
    const DrawerMenu = {
    
      init() {
        drawer = {
          duration: 10,
    
          menu: 'js-drawerMenu',
          menuPanel: 'js-drawerMenuPanel',
          menuToggle: '#js-drawerMenuToggle',
          menuClose: '#js-drawerMenuPanel, #js-drawerMenu .js-scroll',
          // menuAct: 'is-menuOpen',
        };
    
        this.menu();
      },
    
      menu() {
        if (document.getElementById(drawer.menu) != null) {
          let slideoutInst = new Slideout({
            'panel': document.getElementById(drawer.menuPanel),
            'menu': document.getElementById(drawer.menu),
            'duration': drawer.duration,
            // 'openclass': drawer.menuAct,
          });
    
          let nodeList = document.querySelectorAll(drawer.menuToggle);
          let node = Array.prototype.slice.call(nodeList, 0);
          node.forEach(function (elem, index) {
            elem.addEventListener('click', function () {
              slideoutInst.toggle();
            });
          });
    
          let nodeListClose = document.querySelectorAll(drawer.menuClose);
          let nodeClose = Array.prototype.slice.call(nodeListClose, 0);
          nodeClose.forEach(function (elem, index) {
            elem.addEventListener('click', function () {
              slideoutInst.close();
            });
          });
        }
      },
    
    }
    
    

    
    const Wordpress = {
    
      init() {
        wp = {
          editorTarget: 'js-editor',
          tableClass  : 'c-tbl_responsive',
          iframeclass : 'c-iframe',
        };
    
        this.wpEditor();
      },
    
      wpEditor() {
        if ( document.getElementById(wp.editorTarget) != null ) {
          $( '#' + wp.editorTarget + ' table' ).each(function() {
            $(this).wrap('<div class="' + wp.tableClass + '"></div>');
          });
          $( '#' + wp.editorTarget + ' iframe' ).each(function() {
            $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
          });
        }
        // if ( $('.' + wp.editorTarget).length ) {
        //   $( '.' + wp.editorTarget + ' table' ).each(function() {
        //     $(this).wrap('<div class="' + wp.tableClass + '"></div>');
        //   });
        //   $( '.' + wp.editorTarget + ' iframe' ).each(function() {
        //     $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
        //   });
        // }
      }
    
    }
    
    

    
    const SplideSlider = {
    
      init() {
        slider = {
          topKvElm: document.getElementById('js-splideTopKv'),
          topKvHoverElm: document.querySelectorAll('#js-splideTopKv a'),
          optionsKv: {
            autoScroll: {
              speed: .7,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
            type: 'loop',
            autoWidth: true,
            gap: 100,
            arrows: false,
            pagination: false,
            breakpoints: {
              1199.9: {
                gap: 80,
              },
              991.9: {
                gap: 50,
              },
              767.9: {
                destroy: true,
              },
            },
          },
    
          // topLoopElm: document.getElementById('js-splideTopLoop'),
          // optionsLoop: {
          //   autoScroll: {
          //     speed: 0.5,
          //     pauseOnHover: false,
          //     pauseOnFocus: false,
          //   },
          //   type: 'loop',
          //   start: 1,
          //   perPage: 5,
          //   gap: '-4vw',
          //   pagination: false,
          //   arrows: false,
          //   breakpoints: {
          //     1999.9: {
          //       gap: '-7rem',
          //     },
          //     991.9: {
          //       padding: '5vw',
          //       perPage: 2,
          //       gap: '-6rem',
          //     },
          //     767.9: {
          //       padding: '18vw',
          //       perPage: 1,
          //     },
          //     575.9: {
          //       padding: '6vw',
          //     },
          //   },
          // },
    
          textbookElm: document.getElementById('js-splideTextbook'),
          optionsTextbook: {
            perPage: 2,
            autoWidth: true,
            gap: 60,
            arrows: true,
            pagination: false,
            breakpoints: {
              991.9: {
                gap: 40,
              },
              767.9: {
                perPage: 1,
              },
            },
          },
        };
      },
    
      top() {
        if (slider.topKvElm != null) {
          const splideKv = new Splide(slider.topKvElm, slider.optionsKv);
    
          // for (const elm of slider.topKvHoverElm) {
          //   elm.addEventListener('mouseenter', e => {
          //     splideKv.Components.AutoScroll.pause();
          //   });
    
          //   elm.addEventListener('mouseleave', e => {
          //     splideKv.Components.AutoScroll.play();
          //   });
          // }
    
          splideKv.mount(window.splide.Extensions);
        }
    
        // if (slider.topLoopElm != null) {
        //   const splideLoop = new Splide(slider.topLoopElm, slider.optionsLoop);
        //   splideLoop.mount();
        // }
      },
    
      textbook() {
        if (slider.textbookElm != null) {
          const splideTextbook = new Splide(slider.textbookElm, slider.optionsTextbook);
          splideTextbook.mount();
        }
      },
    
    }
    
    

    
    const Animation = {
    
      init() {
        anime = {
          // add: 'js-animeAdd',
    
          // loader: 'js-loader',
          time: (website.page == 'top') ? 400 : 200,
          // word: 'js-animeWord',
        };
    
        // this.addAnime();
        // this.hashPosition();
        // this.word();
      },
    
      check() {
        $('.' + website.targetAnime + ':not(.' + website.actAnime + ')').each(function () {
          let self = $(this),
            targetPosition = self.offset().top,
            triggerPosition,
            shift;
    
          if (website.winWidth < website.shiftPoint) {
            shift = website.winHeight / website.shiftSp;
          } else {
            shift = website.winHeight / website.shiftPc;
          }
          triggerPosition = targetPosition - website.winHeight + shift;
    
          if (website.scrollY > triggerPosition) {
            if (typeof self.data('delay') !== 'undefined') {
              self.css('transitionDelay', self.data('delay') + 'ms')
            }
            self.addClass(website.actAnime);
          }
        });
      },
    
      // addAnime() {
      //   let targets = Array.prototype.slice.call(document.querySelectorAll('.' + anime.add), 0);
      //   targets.forEach((target) => {
      //     if (target.dataset.anime) {
      //       target.style.animation = target.dataset.anime;
      //     }
      //   });
      // },
    
      loader() {
        if (website.page == 'top') {
          // document.getElementById(anime.loader).classList.add(website.act);
        }
    
        setTimeout(function () {
          document.body.classList.add(website.loaded);
        }, anime.time);
      },
    
      hashPosition() {
        if (location.hash != "" && location.hash != "#") {
          let shift = website.headTag.offsetHeight + 15,
            position = $(location.hash).offset().top - shift;
          setTimeout(() => {
            document.documentElement.scrollTop = position;
          }, 50);
        }
      },
    
      // word() {
      //   let wordList = document.querySelectorAll('.' + anime.word),
      //     targetsWord = Array.prototype.slice.call(wordList, 0),
      //     delayHead = 0;
    
      //   targetsWord.forEach((target) => {
      //     let text = target.innerHTML,
      //       html = '',
      //       delay = 200;
    
      //     if (target.dataset.delay) {
      //       delay = target.dataset.delay - 0;
      //     }
    
      //     text.split(' ').forEach(function (w) {
      //       if (w == '<br>') {
      //         html += w;
      //         delay -= 100;
      //       } else if (w == '&nbsp;') {
      //         html += w;
      //       } else {
      //         html += '<span><span style="transition-delay: ' + delay + 'ms;">' + w + '</span></span>';
      //       }
      //       delay += 50;
      //     });
      //     target.innerHTML = html;
      //   });
      // },
    
    }
    
    

    
    const PageScroll = {
    
      init() {
        scrollOption = {
          target: document.getElementById('js-inertiabox'),
          translateY: 0,
          contHeight: 0,
          velocity: 0.08,
    
          animeTargets: document.querySelectorAll('.' + website.targetAnime + ':not(.' + website.actAnime + ')'),
          animeOptions: {
            rootMargin: "-15% 0px",
            threshold: 0,
          },
    
          navDisplayFrame: document.getElementById('js-navDisplay'),
          navDisplayTargets: document.querySelectorAll('.js-navDisplayObserver'),
          navDisplayOptions: {
            rootMargin: "-50% 0px",
            threshold: 0,
          },
        };
    
        // this.observerAnime();
        this.observerNavDisplay();
      },
    
      set() {
        scrollOption.contHeight = scrollOption.target.getBoundingClientRect().height - 1;
        document.body.style.height = Math.floor(scrollOption.contHeight) + 'px';
      },
      smooth() {
        this.set();
    
        let diff = website.scrollY - scrollOption.translateY;
    
        if (diff !== 0) {
          if (Math.abs(diff) > 1) {
            scrollOption.translateY += diff * scrollOption.velocity;
          } else {
            scrollOption.translateY = website.scrollY;
          }
          scrollOption.target.style.transform = 'translate3d(0, -' + scrollOption.translateY + 'px, 0)';
        }
      },
    
      observerAnime() {
        let observer = new IntersectionObserver(this.observerCallbackAnime, scrollOption.animeOptions);
        scrollOption.animeTargets.forEach((target) => {
          if (target.dataset.delay) {
            target.style.transitionDelay = target.dataset.delay + 'ms';
          }
          observer.observe(target);
        });
      },
      observerCallbackAnime(entries, object) {
        entries.forEach(function (entry, i) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(website.actAnime);
          object.unobserve(entry.target);
        });
      },
    
      observerNavDisplay() {
        let observer = new IntersectionObserver(this.observerCallbackNavDisplay, scrollOption.navDisplayOptions);
        scrollOption.navDisplayTargets.forEach((target) => {
          observer.observe(target);
        });
      },
      observerCallbackNavDisplay(entries, object) {
        entries.forEach(function (entry, i) {
          let data = entry.target.dataset.display;
          if (data !== '' && typeof data !== "undefined") {
            let displayClass = "is-" + data;
            if (entry.isIntersecting) {
              scrollOption.navDisplayFrame.classList.add(displayClass);
            } else {
              scrollOption.navDisplayFrame.classList.remove(displayClass);
            }
          }
        });
      },
    }
    


    // OFF

    // ./inc/_parallax.js




    const TopPage = {

      init() {
        top = {
          btnQrTag: document.getElementById('js-btnQr'),
        };

        this.btnQr();
        SplideSlider.top();
      },

      btnQr() {
        if (top.btnQrTag != null && (website.winWidth < website.shiftPoint)) {
          if ((website.scrollY + website.winHeight) >= website.footPos) {
            top.btnQrTag.classList.remove(website.actView);
          } else {
            top.btnQrTag.classList.add(website.actView);
          }
        }
      },

      update() {
      },

    }


    const BasicPage = {

      init() {
        basic = {
          pageTopTag: document.getElementById('js-btnPagetop'),
          btnDownloadTag: document.getElementById('js-btnDownload'),
          // megaMenuTarget: 'js-megaMenu',
          // megaMenuFadeOut: 400,

          dragScrollClass: '.js-dragScroll',

          visibleScrollbarTag: document.getElementById('js-visibleScrollbar')
        };

        this.scrollPaddingTop();
        this.footPosition();
        this.pageTop();
        this.btnDownload();
        this.dragScroll();
        this.visibleScrollbar();
        // this.megaMenuView();
        // this.scrollUpView();

        SplideSlider.textbook();
      },

      scrollPaddingTop() {
        shift = website.headTag.offsetHeight + 20;
        document.documentElement.style.setProperty('--scrollPaddingTop', `${shift}px`);
      },

      footPosition() {
        let footRext = website.footTag.getBoundingClientRect();
        website.footPos = website.scrollY + footRext.top;
      },

      pageTop() {
        if (basic.pageTopTag != null) {

          if (website.scrollY <= 200 || (website.scrollY + website.winHeight) >= website.footPos) {
            basic.pageTopTag.classList.remove(website.actView);
          } else {
            basic.pageTopTag.classList.add(website.actView);
          }
        }
      },

      btnDownload() {
        if (basic.btnDownloadTag != null) {

          if ((website.scrollY + website.winHeight) < website.footPos) {
            basic.btnDownloadTag.classList.remove(website.inact);
          } else {
            basic.btnDownloadTag.classList.add(website.inact);
          }
        }
      },

      dragScroll() {
        $(basic.dragScrollClass).mousedragscrollable();
      },

      visibleScrollbar() {
        if (basic.visibleScrollbarTag != null) {
          let elm = document.getElementById(basic.visibleScrollbarTag.dataset.elm);
          if (elm != null) {
            if (elm.offsetWidth >= elm.scrollWidth) {
              basic.visibleScrollbarTag.style.display = 'none';
            } else {
              basic.visibleScrollbarTag.style.display = 'block';
            }
          }
        }
      },

      // megaMenuView() {
      //   let nodeList = document.querySelectorAll('.' + basic.megaMenuTarget),
      //     timer = {};

      //   nodeList.forEach((target, index) => {
      //     timer[index] = null;

      //     if (website.isDesktop) {
      //       target.addEventListener(`mouseenter`, () => {
      //         clearTimeout(timer[index]);
      //         target.classList.add(website.actView);
      //       });
      //       target.addEventListener(`mouseleave`, () => {
      //         timer[index] = setTimeout(function () { target.classList.remove(website.actView); }, basic.megaMenuFadeOut);
      //       });
      //     } else {
      //       let megamenuNode = target.querySelector('[data-megamenu]');

      //       target.addEventListener(`click`, function (e) {
      //         if (target.classList.contains(website.actView) === true) {
      //           target.classList.remove(website.actView);
      //         } else {
      //           target.classList.add(website.actView);
      //         }
      //       });
      //       megamenuNode.addEventListener(`click`, function (e) {
      //         e.stopPropagation();
      //       });
      //       document.addEventListener('click', (e) => {
      //         if (!e.target.closest('.' + basic.megaMenuTarget)) {
      //           target.classList.remove(website.actView);
      //         }
      //       });
      //     }

      //   });
      // },

      // scrollUpView() {
      //   if (website.scrollY === website.scrollCurrent) {
      //     return;
      //   }

      //   if (website.scrollY <= 10 || website.scrollY < website.scrollCurrent) {
      //     website.headTag.classList.add(website.actView);
      //   } else {
      //     website.headTag.classList.remove(website.actView);
      //   }

      //   website.scrollCurrent = website.scrollY;
      // },

      update() {
      },

    }


    const App = {

      init() {
        if (website.page != 'wp-manual' && website.page != 'wp-manual-single') {
          this.set();
          // this.update();
        } else {
          // Modules.init();
          Wordpress.init();
        }
      },

      set() {
        Modules.init();
        Animation.init();
        PageScroll.init();
        // Parallax.init();
        DrawerMenu.init();
        Wordpress.init();
        SplideSlider.init();
        BasicPage.init();


        if (website.page == 'top') {
          TopPage.init();
          WinScroll.add(TopPage.btnQr);
        }


        WinLoad.add(Animation.loader);
        // WinLoad.add( Modules.alignHeight );
        WinLoad.add(BasicPage.footPosition);

        WinResize.add(Modules.iosCheck);
        WinResize.add(Modules.deviceCheck);
        WinResize.add(BasicPage.footPosition);

        WinResizeWidth.add(Modules.viewportHeight);
        WinResizeWidth.add(Modules.scrollbarWidth);
        WinResizeWidth.add(BasicPage.visibleScrollbar);
        // WinResizeWidth.add( Modules.alignHeight );

        // WinScroll.add( Animation.check );
        WinScroll.add(BasicPage.pageTop);
        WinScroll.add(BasicPage.btnDownload);

        // OrientationChange.add( xxx );


        WinLoad.init();
        WinResize.init();
        WinResizeWidth.init();
        WinScroll.init();
        OrientationChange.init();

      },

      update() {
        // website.animationFrame = window.requestAnimationFrame(App.update);
        // website.winWidth = window.innerWidth;
        // website.winHeight = window.innerHeight;
        // website.scrollY = window.pageYOffset;

        // if (website.isDesktop) {
        //   PageScroll.smooth();

        //   if (mod.cursorMagnet) {
        //     Modules.cursorMagnet();
        //   }

        //   if (website.page == 'top') {
        //     Parallax.moveImg();
        //   }
        // }
      },

    }


    App.init();

  })();


})(jQuery);
